const SECOND = 1e3;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
function duration({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
  ms = 0
}) {
  return ms + seconds * SECOND + minutes * MINUTE + hours * HOUR + days * DAY;
}
function getCalendarDaysBetween(opts) {
  const { fromTimestamp, ianaTimeZone, toTimestamp } = opts;
  const diff = getDateTimestampInTimeZone(toTimestamp, ianaTimeZone) - getDateTimestampInTimeZone(fromTimestamp, ianaTimeZone);
  return diff / duration({ days: 1 });
}
function getDayOfWeek(date) {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  const dayOfWeek = daysOfWeek[date.getUTCDay()];
  if (!dayOfWeek) {
    throw Error(`Invalid date: ${date.toString()}`);
  }
  return dayOfWeek;
}
function getDateTimestampInTimeZone(timestamp, ianaTimeZone) {
  const dateStr = toISOStringInTimeZone(timestamp, ianaTimeZone);
  const tzIndex = Math.max(dateStr.lastIndexOf("+"), dateStr.lastIndexOf("-"));
  const flooredDateStr = dateStr.substring(0, 11) + "00:00:00" + dateStr.substring(tzIndex);
  return new Date(flooredDateStr).getTime();
}
function getTimezoneName() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return void 0;
  }
}
function toISOStringInTimeZone(timestamp, ianaTimeZone) {
  const date = new Date(timestamp);
  const tzDateString = date.toLocaleString("en-US", {
    timeZone: ianaTimeZone,
    hourCycle: "h23"
  });
  const [tzDate, tzTime] = tzDateString.split(", ");
  const [tzMonth, tzDay, tzYear] = tzDate.split("/");
  const utcString = `${tzYear}-${tzMonth.padStart(2, "0")}-${tzDay.padStart(
    2,
    "0"
  )}T${tzTime}.${date.getMilliseconds()}Z`;
  const diffMinutes = Math.floor(
    (new Date(utcString).getTime() - date.getTime()) / (1e3 * 60)
  );
  const tzSeparator = diffMinutes < 0 ? "-" : "+";
  const tzHour = Math.floor(Math.abs(diffMinutes) / 60);
  const tzMinute = Math.abs(diffMinutes) % 60;
  return `${utcString.split("Z")[0]}${tzSeparator}${tzHour.toString().padStart(2, "0")}:${tzMinute.toString().padStart(2, "0")}`;
}
function getAnalyticsTimeProperties(timestamp, ianaTimeZone) {
  const dateISOString = toISOStringInTimeZone(timestamp, ianaTimeZone);
  const dateWithoutTimezone = new Date(dateISOString.split("T")[0]);
  const day = dateWithoutTimezone.getUTCDay();
  const daysFromLastMonday = day === 1 ? 0 : day === 0 ? 6 : day - 1;
  const lastMondayTimestamp = timestamp - duration({ days: daysFromLastMonday });
  const mondayISOString = toISOStringInTimeZone(
    lastMondayTimestamp,
    ianaTimeZone
  );
  return {
    date: dateISOString.slice(0, 10),
    // 2021-06-11
    dateHour: dateISOString.slice(0, 13).replace("T", "-"),
    // 2021-06-11-08
    dateMonth: dateISOString.slice(0, 8) + "01",
    // 2021-06-01
    dateTime: dateISOString,
    // 2021-06-11T08:15:19.953Z
    dateWeek: mondayISOString.slice(0, 10),
    dayOfWeek: getDayOfWeek(dateWithoutTimezone),
    hour: dateISOString.slice(11, 13)
    // 08
  };
}
function unixTimestamp() {
  return Math.floor(Date.now() / 1e3);
}
export {
  duration,
  getAnalyticsTimeProperties,
  getCalendarDaysBetween,
  getDateTimestampInTimeZone,
  getTimezoneName,
  toISOStringInTimeZone,
  unixTimestamp
};
